import {
	ContactIndicatorInitialPatient,
	ContactIndicatorPatient,
	useContactIndicatorModalViewModel,
} from "../useContactIndicatorModalViewModel";

export type PatientCriticalAlert = ContactIndicatorPatient;

const config = {
	indicator: "PACIENTES_INATIVOS" as const,
	stateKey: "pacientesInativos" as const,
	contactOrigin: "CRITICAL_ALERT" as const,
	message: (firstName: string, clinicName: string) =>
		`Olá, ${firstName}! Aqui é da ${clinicName}. Sentimos sua falta e gostaríamos de saber como você está. Podemos ajudar a organizar seu retorno?`,
};

export const useCriticalAlertModalViewModel = (
	isOpen: boolean,
	initialPatient?: ContactIndicatorInitialPatient | null,
	onContactStarted?: (patientId: string) => void
) =>
	useContactIndicatorModalViewModel(isOpen, config, {
		initialPatient,
		onContactStarted,
	});
